/**
 * Shared select option constants used across components
 */

export const SERVICE_TYPES_OPTIONS = [
    {
        id: 'elder_care',
        name: 'Elder Care'
    },
    {
        id: 'housekeeping',
        name: 'Housekeeping'
    },
    {
        id: 'nanny',
        name: 'Nanny'
    }
]

/**
 * The contact type marking the care recipient. Mirrors Contact::TYPE_CARE_RECIPIENT in PHP and is
 * the value stored in client_contacts.type.
 */
export const CARE_RECIPIENT_CONTACT_TYPE = 'Care Recipient'

/**
 * Display label for the care-recipient contact type, qualified by the client record's own type.
 * @param {string|null} clientType - Client.type: 'lead' | 'prospect' | 'client'
 * @returns {string}
 */
export function careRecipientTypeLabel(clientType) {
    const known = ['lead', 'prospect', 'client']
    const normalized = (clientType ?? '').toLowerCase()

    if (!known.includes(normalized)) {
        return CARE_RECIPIENT_CONTACT_TYPE
    }

    return `${CARE_RECIPIENT_CONTACT_TYPE} (${normalized.charAt(0).toUpperCase()}${normalized.slice(1)})`
}

/**
 * Convert an array to select option objects with id and name properties
 * @param {Array} list
 * @param {Function|null} [id_format=null] - Optional callable to format the id
 * @param {Function|null} [name_format=null] - Optional callable to format the name
 * @returns {Array} An array of objects with 'id' and 'name' properties suitable for select options.
 */
export function listToSelectOptions(list, id_format = null, name_format = null) {
    return (list ?? []).map((item, index) => {
        let id = index, name = item

        if (typeof item === 'string') {
            id = item
            name = item
        } else if (typeof item === 'object') {
            id = item.id || index
            name = item.label || item.name || item.id || index
        }

        if (id_format && typeof id_format === 'function') {
            id = id_format(item, index)
        }
        if (name_format && typeof name_format === 'function') {
            name = name_format(item, index)
        }

        return {
            id: id,
            name: name
        }
    })
}
